/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import React from "react";
import BaseCom from "./BaseCom";
import { qreq } from "../shared/qrequest";
import Globals from "../shared/Globals";

export default class UploadImage extends BaseCom {
    constructor(props) {
        super(props);
        this.uploadRef = React.createRef();
        this.captureRef = React.createRef();
        this.dragOver = this.dragOver.bind(this);
        this.dragLeave = this.dragLeave.bind(this);
        this.drop = this.drop.bind(this);
        this.upload = this.upload.bind(this);
        this.load = this.load.bind(this);
    }

    async componentDidMount() {
        document.addEventListener('dragover', this.dragOver);
        document.addEventListener('dragleave', this.dragLeave);
        document.addEventListener('drop', this.drop);
        this.load();
        this.setState({ hasCamera: Globals.isMobile() });
    }

    componentWillUnmount() {
        document.removeEventListener('dragover', this.dragOver);
        document.removeEventListener('dragleave', this.dragLeave);
        document.removeEventListener('drop', this.drop);
    }

    componentDidUpdate(prevProps) {
        if(this.props.fileIdent !== prevProps.fileIdent) {
            this.setState({ fileIdent: this.props.fileIdent });
            this.load();
        }
    }

    load() {
        if(!this.props.fileIdent)
            return;
        qreq.get('/api/storage/get/' + this.props.fileIdent, j => {
            if (j.errorCode === 0) {
                this.setState({ item: j.item });
            }
            else {
                this.unkownErrorCallback();
            }
        }, this.unkownErrorCallback);
    }

    drop() {

    }

    dragOver() {

    }

    dragLeave() {

    }

    upload() {
        var file = this.uploadRef.current.files[0];
        if (file) {
            var reader = new FileReader();
            reader.onload = (e) => {
                this.setState({ image: e.target.result });
                var p = e.target.result.split(',');
                qreq.post('/api/storage/upload-encoded', { base64Content: p[1], mimeType: file.type }, j => {
                    if (j.errorCode === 0) {
                        this.setState({ image: null, item: j.item });
                        this.props.onChange?.(j.item);
                        this.success('Image uploaded successfully!');
                    }
                    else {
                        this.unkownErrorCallback();
                    }
                }, this.unkownErrorCallback);
            }
            reader.readAsDataURL(file);
        }
    }

    render() {
        return <div className={this.props.className}>
            <div className="custom-file">
                {this.state.image ? <img src={this.state.image} alt="Uploaded" style={{ maxWidth: '100%', opacity: '0.5' }} onClick={() => this.uploadRef.current.click()} /> : this.state.item ? <img src={Globals.getImageURL(this.state.item.url)} alt="Uploaded" style={{ maxWidth: '100%' }} onClick={() => this.uploadRef.current.click()} /> : <img src="/img/placeholder.png" alt="Placeholder" style={{ maxWidth: '100%' }} onClick={() => this.uploadRef.current.click()} />}
                
                <input type="file" style={{ display: 'none' }} ref={this.uploadRef} accept="image/*" onChange={this.upload} />
                <input type="file" style={{ display: 'none' }} ref={this.captureRef} accept="image/*" capture="environment" onChange={this.upload} />
                <div className="mt-3">
                    {this.state.hasCamera && <button type="button" className="btn btn-secondary mr-2" onClick={() => this.captureRef.current.click()}>Capture Photo</button>}
                    <button type="button" className="btn btn-primary" onClick={() => this.uploadRef.current.click()}>{this.props.buttonText ?? 'Upload Image'}</button>                    
                </div>
            </div>
        </div>
    }
}
